import { fmt } from "../lib/format";

export function Receipt({ order, tenantName = "Pickfood", storeName = "", copy = false }) {
  if (!order) return null;
  const paid = order.pay_status === "paid";
  return (
    <div id="print-area">
      <div className="receipt-80 mx-auto p-3">
        <div className="text-center">
          <div className="font-bold">Pickfood</div>
          <div className="font-bold text-[14px]">{storeName || tenantName}</div>
          {copy && <div className="border border-black inline-block px-2 mt-1">COPIA</div>}
        </div>
        <hr />
        <div className="text-center">
          <div className="text-[11px]">ORDINE</div>
          <div className="big">#{order.short_code}</div>
        </div>
        <hr />
        <div>Ricevuto: {fmt.dt(order.created_at)}</div>
        <div>Ritiro rich.: {order.pickup_mode === "first" ? "Prima disponibilità" : fmt.dt(order.pickup_at)}</div>
        {order.pickup_confirmed && <div>Ritiro conf.: {fmt.dt(order.pickup_confirmed)}</div>}
        <hr />
        <div>Cliente: {order.customer?.name}</div>
        <div>Tel: {order.customer?.phone}</div>
        <hr />
        {order.items.map((it, idx) => (
          <div key={idx} className="mb-1">
            <div className="flex justify-between font-bold">
              <span>{it.quantity}x {it.name}</span>
              <span>{fmt.eur(it.line_total)}</span>
            </div>
            {it.options?.map((o, i) => (
              <div key={i} className="pl-3 text-[11px]">
                {o.removable ? "- " : "+ "}{o.option_name}{o.price ? ` (${fmt.eur(o.price)})` : ""}
              </div>
            ))}
            {it.note && <div className="pl-3 text-[11px] font-bold">Nota: {it.note}</div>}
          </div>
        ))}
        {order.note && (<><hr /><div className="font-bold">NOTA: {order.note}</div></>)}
        <hr />
        {order.delivery_fee > 0 && (
          <div className="flex justify-between"><span>Consegna</span><span>{fmt.eur(order.delivery_fee)}</span></div>
        )}
        {order.discount > 0 && (
          <div className="flex justify-between font-bold"><span>Sconto {order.coupon?.code || ""}</span><span>-{fmt.eur(order.discount)}</span></div>
        )}
        {order.loyalty_redeemed && order.loyalty_redeemed.amount > 0 && (
          <div className="flex justify-between font-bold"><span>Punti fedeltà</span><span>-{fmt.eur(order.loyalty_redeemed.amount)}</span></div>
        )}
        <div className="flex justify-between big" style={{ fontSize: 18 }}>
          <span>TOTALE</span><span>{fmt.eur(order.total)}</span>
        </div>
        <div className="text-center border border-black mt-2 py-1 font-bold">
          {paid ? "PAGATO ONLINE" : "DA PAGARE AL RITIRO"}
        </div>
        <hr />
        <div className="text-center text-[10px]">powered by Pickfood</div>
      </div>
    </div>
  );
}
